import type { UUID } from "./uuid";

const UUID_GROUPS_PATTERN =
  /^(?=[0-9a-fA-F]{32})([0-9a-fA-F]{8})([0-9a-fA-F]{4})([0-9a-fA-F]{4})([0-9a-fA-F]{4})([0-9a-fA-F]{12})$/;
const CNPJ_GROUPS_PATTERN =
  /^(?=[0-9]{14})([0-9]{2})([0-9]{3})([0-9]{3})([0-9]{4})([0-9]{2})$/;
const BRAZILIAN_PHONE_GROUPS_PATTERN =
  /^([0-9]{2})([0-9]{4}|[0-9]{5})([0-9]{4})$/;

/**
 * Time-based UUID
 * Adds "-" between sections: low time, mid time, mid-time+version, clock sequence, node
 */
export function formatUUID(uuid: UUID) {
  if (uuid.length !== 32) {
    return uuid;
  }

  return uuid.replace(UUID_GROUPS_PATTERN, "$1-$2-$3-$4-$5");
}

/**
 * CNPJ
 * https://en.wikipedia.org/wiki/CNPJ#:~:text=The%20CNPJ%20consists%20of%20a,last%20two%20are%20check%20digits.
 */
export function formatCNPJ(cnpj: string) {
  if (cnpj.length !== 14) {
    return cnpj;
  }

  return cnpj.replace(CNPJ_GROUPS_PATTERN, "$1.$2.$3/$4-$5");
}

/**
 * Brazilian telephone number (10 or 11 digits)
 * https://en.wikipedia.org/wiki/Telephone_numbers_in_Brazil
 */
export function formatBrazilianPhoneNumber(phoneNumber: string) {
  if (phoneNumber.length !== 10 && phoneNumber.length !== 11) {
    return phoneNumber;
  }

  return phoneNumber.replace(BRAZILIAN_PHONE_GROUPS_PATTERN, "$1 $2-$3");
}
